module.exports = __webpack_public_path__ + "img/search-gray.9efcf001.svg";